import { clearStorage, setAuthToken, setRefreshToken } from 'common/requests';
import routes from 'common/routes';
import { FC, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

// USE: http://partners.local.xometry.de:3000/new_pool?redirect_to=/offers/urgent
export const RemoteSignIn: FC = () => {
  const { token } = useParams<{ token: string }>();

  const data = new URLSearchParams(window.location.search);
  const refreshToken = data.get('refresh_token');
  const redirectTo = data.get('redirect_to');

  const history = useHistory();

  useEffect(
    () => {
      clearStorage();

      if (token) {
        setAuthToken(token);
      }

      if (refreshToken) {
        setRefreshToken(refreshToken);
      }

      if (redirectTo) {
        history.push(redirectTo);
      } else {
        history.push(routes.root);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [token],
  );

  return <></>;
};
